import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 122.88 74.46"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.87 47.2a6.33 6.33 0 1 1 8.92-9c8.88 8.85 17.53 17.66 26.53 26.45l-3.76 4.45-.35.37a6.33 6.33 0 0 1-8.95 0zM30 43.55a6.33 6.33 0 1 1 8.82-9.07l25 24.38 47.82-56.57c5.37-6.35 15 1.84 9.66 8.18L69.07 72.22l-.3.33a6.33 6.33 0 0 1-8.95.12zm28.76-4.21-.31.33-9.07-8.85 22.29-26.4c5.37-6.35 15 1.83 9.67 8.18l-22.6 26.74Z"
    }, null, -1)
  ])))
}
export default { render: render }